<template>
  <div>
    <v-row align="center" class="mb-4">
      <v-col cols="12" sm="4" class="text-center">
        <v-progress-circular
          :value="health.score"
          :color="healthColor"
          size="110"
          width="10"
        >
          <span class="text-h5 font-weight-bold">{{ health.score }}%</span>
        </v-progress-circular>
        <div class="text-subtitle-2 grey--text text--darken-1 mt-2">คะแนนความสมบูรณ์ของข้อมูล</div>
      </v-col>
      <v-col cols="12" sm="8">
        <v-list dense class="health-check-list">
          <v-list-item v-for="check in health.checks" :key="check.key" class="px-0">
            <v-list-item-icon class="mr-2">
              <v-icon :color="check.ok ? 'success' : 'warning'" small>
                {{ check.ok ? "mdi-check-circle" : "mdi-alert-circle-outline" }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-body-2">{{ check.label }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>

    <v-divider class="mb-4"></v-divider>

    <v-row>
      <v-col v-for="item in itemsWithCount" :key="item.key" cols="12" sm="6" md="4">
        <v-card outlined class="menu-item-card" :to="item.to" link>
          <v-card-text class="d-flex align-center">
            <v-avatar color="primary lighten-5" size="44" class="mr-3">
              <v-icon color="primary">{{ item.icon }}</v-icon>
            </v-avatar>
            <div class="flex-grow-1">
              <div class="text-body-2 font-weight-medium">{{ item.title }}</div>
              <div class="text-caption grey--text">{{ item.desc }}</div>
            </div>
            <v-chip small :color="item.count === null ? 'grey lighten-3' : 'primary lighten-4'" class="ml-2">
              {{ item.count === null ? "อัตโนมัติ" : item.count + " รายการ" }}
            </v-chip>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "DataOverviewPanel",
  props: {
    menuItems: { type: Array, required: true },
    idCard: { type: String, required: true }
  },
  data() {
    return {
      ApiKey: "HRvec2021",
      categories: [],
      health: { score: 0, checks: [] }
    };
  },
  computed: {
    itemsWithCount() {
      return this.menuItems.map(item => {
        const found = this.categories.find(c => c.key === item.key);
        return { ...item, count: found ? found.count : null };
      });
    },
    healthColor() {
      if (this.health.score >= 80) return "success";
      if (this.health.score >= 50) return "warning";
      return "error";
    }
  },
  watch: {
    idCard(newVal) {
      if (newVal) this.loadOverview();
    }
  },
  mounted() {
    if (this.idCard) this.loadOverview();
  },
  methods: {
    async loadOverview() {
      try {
        let result = await this.$http.post("user_data_overview.php", {
          ApiKey: this.ApiKey,
          id_card: this.idCard
        });
        if (result.data && result.data.status) {
          this.categories = result.data.categories || [];
          this.health = result.data.health || { score: 0, checks: [] };
        }
      } catch (e) {
        console.error("Error loading data overview:", e);
      }
    }
  }
};
</script>

<style scoped>
.menu-item-card {
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.menu-item-card:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}
.health-check-list .v-list-item {
  min-height: 32px;
}
</style>
